export const switchMode = () => dispatch => {
    dispatch({
        type: "SWITCH_MODE"
    });
}
